export default "__VITE_ASSET__DDZdEHYJ__"